import { render, staticRenderFns } from "./EditWorkplaceList.vue?vue&type=template&id=5fa70efa"
import script from "./EditWorkplaceList.vue?vue&type=script&lang=js"
export * from "./EditWorkplaceList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports